import React, { PureComponent } from 'react';
import './STATUSBAR.css';

export default class STATUSBAR extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let parts = this.props.parts || [ null ];

        return <div className={"statusbar-container " + (this.props.className || "")}>
            {this.props.children}

            <div className="statusbar">
                {parts.map((part, i) => {
                    return <div key={i} className="statusbar-part">{part}</div>;
                })}
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/walleris/STATUSBAR.js